module.exports = __webpack_public_path__ + "static/media/uci.9e3f98e9.png";